import { api } from '@/lib/api';
import type { AdvanceLabFulfillmentInput, LabFulfillment } from './types';

// ---- Vendor (provider) ----
export async function get_vendor_fulfillment(booking_id: string): Promise<LabFulfillment> {
  const res = await api.get<LabFulfillment>(`/vendor/bookings/${booking_id}/lab`);
  return res.data;
}

export async function advance_fulfillment(
  booking_id: string,
  input: AdvanceLabFulfillmentInput,
): Promise<LabFulfillment> {
  const res = await api.post<LabFulfillment>(`/vendor/bookings/${booking_id}/lab/advance`, input);
  return res.data;
}

// ---- Owner ----
export async function get_owner_fulfillment(booking_id: string): Promise<LabFulfillment> {
  const res = await api.get<LabFulfillment>(`/user/bookings/${booking_id}/lab`);
  return res.data;
}
